
import { combineReducers } from 'redux'
import shippingCostInfo from './ShippingCostInfoModal/shippingCostInfoSlice'

export default combineReducers({
	shippingCostInfo,
})
